// extracted by mini-css-extract-plugin
export default {"finalStepWrapper":"FinalStep_finalStepWrapper__GsAWy","text":"FinalStep_text__YtSNN","checkedIcon":"FinalStep_checkedIcon__Zdkqt"};